import * as yup from "yup";
import Toast from "helper/toast";

//////////////////// types ////////////////////
const FILE_TYPES = {
  file: "فایل",
  image: "عکس",
  video: "ویدئو",
};

//////////////////// types ////////////////////
const REGEX_OPTIONS = {
  phoneNumber: new RegExp("^09(1[0-9]|3[1-9]|2[1-9])-?[0-9]{3}-?[0-9]{4}$"),
  email: new RegExp(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i),
};

//////////////////// file sizes and formates ////////////////////
export const FILE_SIZE = 10_000_000; //10 meg

//////////////////// constant validation message ////////////////////
export function strings({ title = "فیلد", size = "۵ مگ" }) {
  return {
    required: "این فیلد حتما باید پر شود",
    notMatch: title + " نامعتبر است ",
    size: `سایز ${title} باید کمتر از ${size} باشد`,
    min: `${title} حداقل باید ${size} کاراکتر باشد`,
    max: `${title} حداکثر باید ${size} کاراکتر باشد`,
    unSupported: `فرمت ${title} نامعتبر است`,
  };
}

/////////////////// convert empty stringToNull ///////////////////
export function emptyStringToNull(value, originalValue) {
  if (typeof originalValue === "string" && originalValue.trim() === "") {
    return null;
  }
  return value;
}

///////////////// Image validator ///////////////////
export function validateImg(file) {
  if (!(file.type.split("/")[0] === "image")) {
     Toast({
      type: "custom",
      title: `فرمت عکس نامعبتر است`,
      autoClose: 3000,
    });
    return false
  } else if (file.size > FILE_SIZE) {
    Toast({
      type: "custom",
      //converting kb to megabyte
      title: `حجم عکس باید کمتر از ${FILE_SIZE / 1_000_000}  مگ باشد`,
      autoClose: 3000,
    });
    return false
  }
  return true
}

////////////////// validateFile //////////////
export function validateFile({
  file,
  title = "",
  limit = FILE_SIZE,
  file_formats = [],
  type = "file",
}) {
  if (!file) return false;
  const file_type = /[^.]+$/.exec(file.name)[0];
  const format = file_formats.find((item) => item.toLowerCase() === file_type.toLowerCase());

  if (!file_type || !format) {
    Toast({
      type: "custom-warn",
      title: `فرمت ${
        FILE_TYPES[type]
      } ${title} نامعبتر است. (${file_formats.join()})`,
      autoClose: 4000,
    });
    return false;
  }
  if (file.size > limit * 10_000_000) {
    Toast({
      type: "custom-warn",
      title: `حجم ${FILE_TYPES[type]} ${title} باید کمتر از ${limit}  مگ باشد`,
      autoClose: 4000,
    });
    return false;
  }
  return true;
}

// template validate
export const templateValidates = ({ type }) => {
  switch (type) {
    case "number":
      return yup
        .number()
        .typeError("فقط مقدار عدد مجاز است")
        .nullable(true)
        .transform((v, o) => (o === "" ? null : v));

    case "password":
      return yup
        .string()
        .min(6, "حداقل 6 نویسه اجباری میباشد")
        .nullable()
        .transform((v, o) => (o === "" ? null : v));

    case "confirm_password":
      return yup
        .string()
        .oneOf([yup.ref("password"), null], "باید مشابه فیلد رمز ورود باشد")
        .min(6, "حداقل 6 نویسه اجباری میباشد")
        .nullable()
        .transform((v, o) => (o === "" ? null : v));

    case "phone_number":
      return yup
        .string()
        .matches(REGEX_OPTIONS.phoneNumber, "شماره تماس نامعتبر است")
        .nullable()
        .transform((v, o) => (o === "" ? null : v));

    case "email":
      return yup
        .string()
        .matches(REGEX_OPTIONS.email, "ایمیل نامعتبر است")
        .nullable()
        .transform((v, o) => (o === "" ? null : v));

    default:
      return yup.string();
  }
};
